<template>
<div
    class="login-box"
    style="min-height: 873px;"
>
    <div class="box-header with-border">

    </div>
    <div class="login-box-body">
        <h4 class="login-box-msg">{{$t('RECOVER PASSWORD')}}</h4>

        <form v-on:submit.prevent>

            <br>
            <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-envelope"></i></span>
                <input
                    type="email"
                    v-model="email"
                    class="form-control"
                    placeholder="Email"
                >
            </div>
            <br>

            <div class="form-group has-error">
                <label
                    class="control-label"
                    for="inputError"
                >
                    {{ error_message }}
                    </label>
            </div>
            <br>
            <button
                class="btn btn-primary"
                @click="send"
            >{{ $t('SEND') }}</button>
                <router-link
                    to="/"
                    class="btn btn-default"
                >{{$t('CANCEL')}}</router-link>
        </form>
        <div v-if="loading==true">
            <center>
                <div
                    class="fa fa-circle-o-notch fa-spin text-blue"
                    style="font-size:50px;"
                ></div>
        </center>
    </div>
    </div>

    </div>
</template>

<script>
import swal from 'sweetalert'
export default {
    name: "forgotpassword",
    data() {
        return {
            email: '',
            error_message: '',
            loading: false
        };
    },
    methods: {
        async send() {
            let self = this;
            try {
               
                if (this.email.length > 5) {
                     this.error_message='';
                    this.loading = true;
                    let response = await this.$store.state.services.userService.forgotPassword({
                        email: this.email
                    })
                    this.loading = false;
                    swal({
                        title: this.$t('SEND EMAIL'),
                        text: this.$t('THE PASSWORD RECOVERED HAS BEEN SENT'),
                        icon: 'success'
                    }).then(clicked => {
                        self.email = '';
                        self.$router.push('/');
                    })

                } else {
                    this.error_message = this.$t('EMAIL_CHECKED')
                }

            } catch (error) {
                this.loading = false;

                swal({
                    title: this.$t("SOMETHING IS WRONG"),
                    text: error.response.data.error,
                    icon: "error"
                });

            }

        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/Users/forgotpassword.vue